var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "700px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { staticClass: "spacing" },
            [
              _c("el-form-item", [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("div", { staticClass: "frm" })
                ]),
                _vm._v(" " + _vm._s(_vm.$t("SeaExport.BasicInfo")) + " ")
              ])
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "120px",
                "label-position": "right",
                disabled: _vm.look
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("FbaChannel.channelName")))]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "120px" },
                            attrs: { no: "channelName" },
                            model: {
                              value: _vm.form.channelName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "channelName", $$v)
                              },
                              expression: "form.channelName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("FbaChannel.shippingType")))]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              no: "shippingType",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_FbaJobConstants$SHIPPING_TYPES,
                              filterable: "",
                              clearable: true,
                              "default-value": _vm.form.shippingType
                            },
                            on: { parentCallBack: _vm.shippingTypeChange }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "120px",
                "label-position": "right",
                disabled: _vm.look
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FbaChannel.destinationDistribution")
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              no: "destinationDistribution",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES,
                              filterable: "",
                              clearable: true,
                              "default-value":
                                _vm.form.destinationDistribution + ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.destinationDistribution = Number(
                                  p.value
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            { staticClass: "spacing" },
            [
              _c("el-form-item", [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("div", { staticClass: "frm" })
                ]),
                _vm._v(" " + _vm._s(_vm.$t("FbaChannel.weightInfo")) + " ")
              ])
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "120px",
                "label-position": "right",
                disabled: _vm.look
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("FbaChannel.chargingMethod"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.chargingMethod,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "chargingMethod", $$v)
                                },
                                expression: "form.chargingMethod"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(_vm._s("KG"))
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s("CBM"))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("FbaChannel.bubbleCountingRatio"))
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              no: "bubbleCountingRatio",
                              "controls-position": "right",
                              max: 9999,
                              min: 1,
                              precision: 0
                            },
                            model: {
                              value: _vm.form.bubbleCountingRatio,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bubbleCountingRatio", $$v)
                              },
                              expression: "form.bubbleCountingRatio"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "120px",
                "label-position": "right",
                disabled: _vm.look
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "FbaChannel.singleBoxLowestBillableWeight"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              no: "singleBoxLowestBillableWeight",
                              "controls-position": "right",
                              max: 999.99,
                              min: 0,
                              precision: 2
                            },
                            model: {
                              value: _vm.form.singleBoxLowestBillableWeight,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "singleBoxLowestBillableWeight",
                                  $$v
                                )
                              },
                              expression: "form.singleBoxLowestBillableWeight"
                            }
                          }),
                          _vm._v(" " + _vm._s("KG") + " ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              staticStyle: { "margin-right": "4px" },
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "FbaChannel.multipleBoxesCalculationRules"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                slot: "label",
                                placement: "bottom",
                                trigger: "hover"
                              },
                              slot: "label"
                            },
                            [
                              _c("div", { staticClass: "pop-content" }, [
                                _vm._v(_vm._s("什么是多箱计算规则？"))
                              ]),
                              _c("div", { staticClass: "pop-content" }, [
                                _vm._v(
                                  _vm._s(
                                    "多箱计算规则是用于在一单多箱的情况下，根据每箱货的重量、体积计算整个订单的结算重，目前包括两种可选规则：先累加再比较、先比较再累加；"
                                  )
                                )
                              ]),
                              _c("div", { staticClass: "pop-content" }, [
                                _vm._v(
                                  _vm._s(
                                    "先累加再比较：先将单箱的重量做累加、将单箱的体积做累加，再根据重量体积转换系数转换后取较大值，得到最终的结算重；"
                                  )
                                )
                              ]),
                              _c("div", { staticClass: "pop-content" }, [
                                _vm._v(
                                  _vm._s(
                                    "先比较再累加：分别对每一箱的重量和体积，根据重量体积转换系数转换后取较大值，之后累加得到结算重；"
                                  )
                                )
                              ]),
                              _c("svg-icon", {
                                staticStyle: {
                                  "font-size": "14px",
                                  "margin-right": "0"
                                },
                                attrs: {
                                  slot: "reference",
                                  "icon-class": "question"
                                },
                                slot: "reference"
                              })
                            ],
                            1
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              no: "multipleBoxesCalculationRules",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_FbaJobConstants$MULTIPLE_BOXES_CALCULATION_RULES,
                              filterable: "",
                              clearable: false,
                              "default-value":
                                _vm.form.multipleBoxesCalculationRules
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.multipleBoxesCalculationRules = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "120px",
                "label-position": "right",
                disabled: _vm.look
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "FbaChannel.settlementWeightRoundingRules"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              no: "settlementWeightRoundingRules",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_FbaJobConstants$SETTLEMENT_WEIGHT_ROUNDING_RULES,
                              filterable: "",
                              clearable: true,
                              "default-value":
                                _vm.form.settlementWeightRoundingRules
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.settlementWeightRoundingRules = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FbaChannel.BubbleSplittingRatio")
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              no: "bubbleSplittingRatio",
                              "controls-position": "right",
                              max: 100,
                              min: 0,
                              precision: 0
                            },
                            model: {
                              value: _vm.form.bubbleSplittingRatio,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bubbleSplittingRatio", $$v)
                              },
                              expression: "form.bubbleSplittingRatio"
                            }
                          }),
                          _vm._v(" " + _vm._s("%") + " ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            { staticClass: "spacing" },
            [
              _c("el-form-item", [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("div", { staticClass: "frm" })
                ]),
                _vm._v(" " + _vm._s(_vm.$t("FbaChannel.acceptableGoods")) + " ")
              ]),
              _c(
                "el-form",
                { staticClass: "spacing", attrs: { disabled: _vm.look } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          staticStyle: { "margin-left": "20px" },
                          on: { change: _vm.acceptableGoodsChangeHandler },
                          model: {
                            value: _vm.acceptableGoods,
                            callback: function($$v) {
                              _vm.acceptableGoods = $$v
                            },
                            expression: "acceptableGoods"
                          }
                        },
                        _vm._l(_vm.fbaCargoType, function(item) {
                          return _c(
                            "el-checkbox",
                            { key: item.code, attrs: { label: item.code } },
                            [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.look, type: "primary", no: "save" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }